// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Uds73NTEHsC5Z0edXxoM.DgvbsLbXw88_p5JMvKrP{cursor:auto}.BMvT2HIhbpMhKKw93oBc{align-items:center;gap:8px;display:flex}.BMvT2HIhbpMhKKw93oBc .KHpJD3OFmXAaTBZG4wYC{background-color:var(--border-neutral-primary);width:1px;height:16px}.BMvT2HIhbpMhKKw93oBc .w0PgbFHlpcj3dRDPtKsN{padding:0;font-size:14px;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textField": `Uds73NTEHsC5Z0edXxoM`,
	"disabled": `DgvbsLbXw88_p5JMvKrP`,
	"leftContentNumber": `BMvT2HIhbpMhKKw93oBc`,
	"verticalDivider": `KHpJD3OFmXAaTBZG4wYC`,
	"countryPicker": `w0PgbFHlpcj3dRDPtKsN`
};
export default ___CSS_LOADER_EXPORT___;
